import React from 'react'

import { useFormattedCurrentDateParts } from '@/components/Event/NewScript/hooks/useFormattedCurrentDateParts'
import { useStatePolicies } from '@/components/Event/NewScript/hooks/useStatePolicy'
import { isExaminationUnderOath } from '@/components/Event/NewScript/utils/event'
import { Event } from '@/types'
import { getEventTimezone } from '@/utils/time'

export type ClosingVerbatimProps = {
  event: Event
}

export const ClosingVerbatim: React.FC<ClosingVerbatimProps> = ({ event }) => {
  const { formattedTimeWithTimezone } = useFormattedCurrentDateParts(
    getEventTimezone(event),
  )
  const { nonDefaultClosingVerbatim } = useStatePolicies(event)
  const isEUO = isExaminationUnderOath(event)

  if (nonDefaultClosingVerbatim) {
    return (
      <>
        Counsel, before we conclude, are there any additional stipulations or
        other matters you’d like to place on the record before we go off the
        record?
        <br />
        <br />
        Hearing nothing further, this concludes the{' '}
        {isEUO ? 'examination' : 'deposition'}. The time is{' '}
        {formattedTimeWithTimezone}, and we are now off the record.
      </>
    )
  }

  return (
    <>
      If there is nothing further, please allow me to take us off the record. It
      is {formattedTimeWithTimezone} and we are now off the record.
    </>
  )
}
